import React, { useState } from 'react'
import { PasswordResetInput, UnRequiredInput } from '../../../common/input'
import TextArea from '../../../common/TextArea'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { debatePsychometricsFactCheckMe, debatePsychometricsSuggest } from '../../../../redux/Thunks/debatesThunk'
import { userInfo } from '../../../../redux/Selectors/selectors'


const argumentData = ["Oppose", "Support"]

const SuggestionForm = ({data, closeForm, isMe}) => {

  const currentLoggedInUser = useSelector(userInfo)
  const { debate_id } = useParams()
  const dispatch = useDispatch()

  const [inputValue, setInputValue] = useState({
    source: isMe ? data?.data?.evidence : "",
    opinion: isMe ? data?.data?.claim : "",
    argument: "",
  })

  const [errorMsg, setErrorMsg] = useState("")
  const [mainErrorMsg, setMainErrorMsg] = useState("")


  const handleChange = (e) => {
    setMainErrorMsg("")
    setErrorMsg("")
    const {name, value} = e.target

    setInputValue((prevValue) => {
      return {
        ...prevValue,
        [name] : value
      }
    })
  }

  const handleArgument = (item) => {
    setMainErrorMsg("")
    setErrorMsg("")
    setInputValue((prevValue) => {
      return {
        ...prevValue,
        "argument": item
      }
    })
  }



  const suggestionClick = (e) => {
    e.preventDefault()

    if(inputValue.source && !inputValue.source.startsWith("https")){
      setErrorMsg("You must provide a valid url")
      return
    }

    const parentArgumentData = data?.data

    if(isMe){
      const body = {
        opinion: inputValue?.opinion,
        source: inputValue?.source,
        username: parentArgumentData?.user,
        node_id: parentArgumentData?.id,
        debate_id
      }

      dispatch(debatePsychometricsFactCheckMe(body))

    }else{
      
      if(!inputValue.argument){
        setMainErrorMsg("Select an argument type (e.g Support)")
        return 
      }
      const body = {
        ...inputValue,
        target_id : parentArgumentData?.id,
        username : currentLoggedInUser?.name,
        debate_id
      }
  
      dispatch(debatePsychometricsSuggest(body))
    }
    
    setInputValue({
      source: "",
      opinion: "",
      argument: "",
  })

  closeForm()

  }


  return (
    <form className='mt-4 mb-2' onSubmit={suggestionClick}>
    <div className='relative h-[300px]  bg-white rounded-xl'>
    
    <p className='font-semibold p-3 text-black'>
    {isMe ? "Fact Check AI on your comment" : "Any thoughts?" }</p>

    <p className='text-red-600 my-3 px-3'>{mainErrorMsg}</p>

    <div className={`w-3/4 px-3 pb-5 my-4 ${isMe ? "h-[200px]" : "h-[150px]"} overflow-y-scroll`}>
    <TextArea
      label="Suggestion"
      value={inputValue?.opinion}
      name="opinion"
      handleChange={handleChange}
      whiteBg={true}
      rows={3}
      cols={5}
      placeholder="Write your opinion"
       />

  <p className='text-red-600 mt-5'>{errorMsg}</p>

  {/* Make Source Required if user is fact checking their own comment */}
  {isMe ? 
    <PasswordResetInput
      label="Source (if any)"
      value={inputValue?.source}
      name="source"
      handleChange={handleChange}
      placeholder="Link only"
      whiteBg={true}
       />
  :
  <UnRequiredInput
      label="Source (if any)"
      value={inputValue?.source}
      name="source"
      handleChange={handleChange}
      placeholder="Link only"
      whiteBg={true}
       />
  }
    </div>

    

    {!isMe &&
    <div className='absolute bottom-3 left-2 flex rounded-md bg-[#D9D9D9] space-x-5'>
      {argumentData.map((item) => {
        return (
        <button  key={item} type="button" 
        onClick={() => {
          handleArgument(item)
        }}
        className={`text-black px-3 border-none hover:border-[0.5px] hover:font-semibold
        ${inputValue.argument === item && "bg-[#474B7D]"}
       hover:bg-[#474B7D] rounded-lg`}>
        {item}
      </button>)
      })}
    </div>
    }


    <button className='absolute bg-[#7AA65F] rounded-lg text-sm md:text-lg
                  py-2 px-7 text-white bottom-3 right-2'>
            {isMe ? "Edit" : "Suggest"}
        </button>
    </div>

    </form>
  )
}

export default SuggestionForm